
// Simplified daily usage service replacement
export interface UsageResult {
  canUse: boolean;
  remaining: number;
  used: number;
}

export const checkDailyUsageLimit = async (
  userId: string, 
  feature: string, 
  limit: number
): Promise<UsageResult> => {
  // Since we removed the complex daily usage system, 
  // we'll use localStorage for simple client-side tracking
  const today = new Date().toDateString();
  const key = `usage_${userId}_${feature}_${today}`;
  const used = parseInt(localStorage.getItem(key) || '0');
  
  return {
    canUse: used < limit,
    remaining: Math.max(0, limit - used),
    used
  };
};

export const incrementDailyUsage = async (
  userId: string,
  feature: string,
  limit: number
): Promise<boolean> => {
  try {
    const today = new Date().toDateString();
    const key = `usage_${userId}_${feature}_${today}`;
    const used = parseInt(localStorage.getItem(key) || '0');
    
    if (used < limit) {
      localStorage.setItem(key, (used + 1).toString());
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error incrementing daily usage:', error);
    return false;
  }
};
